import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { Container, Row, Col } from "react-bootstrap";

//icon
import IconView from "./IconView";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import styled from "styled-components";

const FormtitleLable = styled.div`
  margin-top: 5px;
  position: relative;
  text-align: center;
  width: ${(props) => props.width}px;
`;
const IconLable = styled.button`
  border-radius: 3px;
  text-align: center;
  padding: 1px 3px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;

const IconWrap = (props) => {
  return (
    <FormtitleLable
      width={props.width}
      className="d-inline "
      onClick={props.onClick}
    >
      <IconLable>{props.children}</IconLable>
    </FormtitleLable>
  );
};

class TimecodeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Timecode的位置
      timecode_top: -1000,
      timecode_left: -1000,

      subtitle_top: -1000,
      subtitle_left: -1000,
      readOnly: false,
    };
    this.setPosition = this.setPosition.bind(this);
  }

  //設定位置
  setPosition(type, top, left) {
    if (type === 0) {
      //時間
      this.setState({ timecode_top: top });
      this.setState({ timecode_left: left });
    } else {
      //字幕
      this.setState({ subtitle_top: top });
      this.setState({ subtitle_left: left });
    }
  }
  async componentDidMount() {
    this.props.onRef(this);
    this.setState({ readOnly: this.props.readOnly });
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  async componentWillReceiveProps(nextProps) {
    this.setState({ readOnly: nextProps.readOnly });
  }
  render() {
    const { readOnly } = this.state;

    const Timecode = styled.div`
      text-align-last: justify;
      width: 70px;
      position: absolute;
      top: ${(props) => props.top}px;
      left: ${(props) => props.left}px;
      z-index: 100;
    `;

    const SubtitleView = styled.div`
      text-align-last: justify;
      width: 285px;
      position: absolute;
      top: ${(props) => props.top}px;
      left: ${(props) => props.left}px;
      z-index: 100;
    `;

    let contentView;
    if (this.props.type === 0) {
      contentView = (
        <Timecode top={this.state.timecode_top} left={this.state.timecode_left}>
          <Container className={"p-0 m-0"}>
            <Row className={"p-0 m-0"}>
              {readOnly === false ? (
                <IconWrap width={20}>
                  <Icon
                    color="blue"
                    name="chevron left"
                    size="tiny"
                    onClick={() => {
                      this.props.chevronEvent("left");
                    }}
                    // style={{float: 'left'}}
                  />
                </IconWrap>
              ) : null}

              <IconWrap width={20}>
                <Icon
                  color="blue"
                  name="pause"
                  size="tiny"
                  onClick={() => {
                    this.props.timecode_stopClick();
                  }}
                  // style={{marginLeft:' 19px'}}
                />
              </IconWrap>

              {readOnly === false ? (
                <IconWrap width={20}>
                  <Icon
                    color="blue"
                    name="chevron right"
                    size="tiny"
                    // style={{float: 'right'}}
                    onClick={() => {
                      this.props.chevronEvent("right");
                    }}
                  />
                </IconWrap>
              ) : null}
            </Row>
          </Container>
        </Timecode>
      );
    } else {
      contentView = (
        <SubtitleView
          top={this.state.subtitle_top}
          left={this.state.subtitle_left}
          ref={(c) => (this.subtitleViewComponent = c)}
          id="subtitle-buttons"
        >
          <Container className={"p-0 m-0"}>
            <Row className={"p-0 m-0"}>
              <IconWrap
                width={20}
                onClick={() => {
                  this.props.playhere();
                }}
              >
                <Icon color="blue" name="play" size="tiny" />
              </IconWrap>

              <IconWrap
                width={20}
                onClick={() => {
                  this.props.editTablePause();
                }}
              >
                <Icon color="blue" name="pause" size="tiny" />
              </IconWrap>

              {readOnly === false ? (
                <IconWrap width={20}>
                  <Icon
                    color="blue"
                    name="plus"
                    size="tiny"
                    onClick={() => {
                      this.props.add_Row();
                    }}
                  />
                </IconWrap>
              ) : null}

              {readOnly === false ? (
                <IconWrap width={38}>
                  <IconView
                    buttonName="resize-full"
                    enableAct={true}
                    onClick={() => {
                      this.props.resize_full();
                    }}
                  />
                </IconWrap>
              ) : null}

              {readOnly === false ? (
                <IconWrap width={38}>
                  <IconView
                    buttonName="resize-small"
                    enableAct={true}
                    onClick={() => {
                      this.props.resize_small();
                    }}
                  />
                </IconWrap>
              ) : null}

              {readOnly === false ? (
                <IconWrap width={20}>
                  <Icon
                    color="blue"
                    name="remove"
                    size="tiny"
                    onClick={() => {
                      this.props.delete_Row();
                    }}
                  />
                </IconWrap>
              ) : null}

              {readOnly === false ? (
                <IconWrap width={20}>
                  <Icon
                    color="blue"
                    name="italic"
                    size="tiny"
                    onClick={() => {
                      // if (window.confirm('Delete this row?')){
                      //
                      // }

                      this.props.decorativeLettering(false);
                    }}
                  />
                </IconWrap>
              ) : null}
            </Row>
          </Container>
        </SubtitleView>
      );
    }

    return contentView;
  }
}

TimecodeView.propTypes = {};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(withRouter(TimecodeView));



// WEBPACK FOOTER //
// ./src/components/common/TimecodeView.js